import { menuDetailSearch } from '../backoffice/routes';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const gudangRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'gudang',
  component: lazyRouteComponent(() => import('./layout'), 'GudangLayout'),
});

const menuDetailRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'menu/$itemId',
  validateSearch: menuDetailSearch,
  component: lazyRouteComponent(
    () => import('../backoffice/pages/menu-item-detail'),
    'MenuItemDetailPage',
  ),
});

const menuAnalyticsRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'menu',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/menu-analytics'),
    'MenuAnalyticsPage',
  ),
});

const overviewRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/overview-page'), 'OverviewPage'),
});

const layoutRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'lokasi/$locationId',
  component: lazyRouteComponent(() => import('./pages/layout-page'), 'LayoutRoutePage'),
});

const receivingRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'penerimaan',
  component: lazyRouteComponent(() => import('./pages/receiving-page'), 'ReceivingPage'),
});

const directReceiptRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'penerimaan/baru',
  component: lazyRouteComponent(() => import('./pages/direct-receipt-page'), 'DirectReceiptPage'),
});

const receiptRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'penerimaan/$receiptId',
  component: lazyRouteComponent(
    () => import('./pages/receipt-detail-page'),
    'ReceiptDetailRoutePage',
  ),
});

const quarantineRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'karantina',
  component: lazyRouteComponent(() => import('./pages/quarantine-page'), 'QuarantinePage'),
});

const checklistsRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'pemeriksaan',
  component: lazyRouteComponent(() => import('./pages/checklists-page'), 'ChecklistsPage'),
});

const tasksRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'tugas',
  component: lazyRouteComponent(() => import('./pages/tasks-page'), 'TasksPage'),
});

const requisitionsRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'permintaan',
  component: lazyRouteComponent(() => import('./pages/requisitions-page'), 'RequisitionsPage'),
});

const requisitionRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: 'permintaan/$requisitionId',
  component: lazyRouteComponent(
    () => import('./pages/requisitions-page'),
    'RequisitionDetailRoutePage',
  ),
});

export const gudangTree = gudangRoute.addChildren([
  menuAnalyticsRoute,
  menuDetailRoute,
  overviewRoute,
  layoutRoute,
  receivingRoute,
  directReceiptRoute,
  receiptRoute,
  quarantineRoute,
  checklistsRoute,
  tasksRoute,
  requisitionsRoute,
  requisitionRoute,
]);
